import type { ClientStatus } from '../../types/clients';
import type { BadgeVariant } from '../../components/ui/Badge';

export const GENDER_OPTIONS = [
  { value: '', label: 'Select gender...' },
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Non-binary', label: 'Non-binary' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
  { value: 'Other', label: 'Other' },
];

/**
 * THE client status option set (ADO #584). Edit Client, the bulk Update Status dialog
 * and the detail drawer's status menu all render from `clientStatusOptions`, so they
 * can't drift apart again. (Edit Client used to carry its own copy without Inactive,
 * which steered users to Discharged when they meant Inactive — see #583 / #536.)
 */
export const STATUS_OPTIONS: { value: ClientStatus; label: string }[] = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'DISCHARGED', label: 'Discharged' },
  { value: 'ON_HOLD', label: 'On Hold' },
];

/**
 * The statuses a user may choose. Inactive is offered only to callers who can set it
 * (see `useCanSetClientInactive`); the server 403s anyone else, so don't offer an option
 * guaranteed to fail.
 */
export function clientStatusOptions(canSetInactive: boolean) {
  return canSetInactive ? STATUS_OPTIONS : STATUS_OPTIONS.filter((o) => o.value !== 'INACTIVE');
}

export const CLIENT_STATUS_BADGE_VARIANT: Record<ClientStatus, BadgeVariant> = {
  ACTIVE: 'success',
  INACTIVE: 'neutral',
  DISCHARGED: 'error',
  ON_HOLD: 'warning',
};

export const CLIENT_STATUS_LABEL: Record<ClientStatus, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISCHARGED: 'Discharged',
  ON_HOLD: 'On Hold',
};
